import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import Link from 'components/common/A'
import { GtmAgent } from 'utils/hooks/analytics'

const VenderRelatedLinks = ({
  links,
  vender,
  clickLocation,
  onExternalLinkClick,
  ...boxProps
}) => {
  const onLinkClick = (event, link) => {
    event.preventDefault()
    GtmAgent.directSendToGTM({
      event: 'living_action',
      living_event_name: 'booking_service_otherlink',
      living_click_name: link.name,
      living_click_location: clickLocation,
      living_vender: vender?.name,
      living_vender_id: vender?._id,
    })
    onExternalLinkClick?.(link.url, link.name)
  }

  return (
    <Box display="flex" flexWrap="wrap" {...boxProps}>
      {links.map((link) => (
        <Link
          key={link.id}
          href={link.url}
          rel="noopener noreferrer"
          onClick={(event) => onLinkClick(event, link)}
        >
          <Typography fontWeight="fontWeightBold" color="primary.main">
            {link.name}
          </Typography>
        </Link>
      ))}
    </Box>
  )
}

VenderRelatedLinks.defaultProps = {
  links: [],
}

export default VenderRelatedLinks
